
import { formatQuantityWithUnit, parseDateToYYMMDD } from '@/utils/helpers'
import { getNestedValue } from '@/utils/tableUtils'
import { formatTimestamp } from '@/utils/timeUtils'
import { IManufacturingPlan } from '@/utils/types/model/manufacturingPlan'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

interface IManufacturingOrderColumn {
  prop: string
  label: string
  formatter?: (row: IManufacturingPlan) => string
  width?: number
}

@Options({
  name: 'ManufacturingOrderTable',
})
export default class ManufacturingOrderTable extends Vue {
  @Prop({ type: Object, required: true }) mo!: IManufacturingPlan
  @Prop({ type: String, default: '' }) tableClass!: string

  formatTime(dateStr: string): string {
    return formatTimestamp(dateStr)
  }

  get columns(): IManufacturingOrderColumn[] {
    return [
      { prop: 'orderNumber', label: this.$t('manufacturing_order_no') as string },
      {
        prop: 'manufactureCompletionDate',
        label: this.$t('manufacture_completion_date') as string,
        formatter: (row: IManufacturingPlan) => this.formatTime(row.manufactureCompletionDate || ''),
      },
      {
        prop: 'workCenterCode',
        label: this.$t('barcode.workCenterCode') as string,
        formatter: (row: IManufacturingPlan) => `${row.workCenterCode} - ${row.workCenterName}`,
      },
      {
        prop: 'itemCode',
        label: this.$t('item_code') as string,
        formatter: (row: IManufacturingPlan) => `${row.itemCode} - ${row.itemName}`,
      },
      {
        prop: 'plannedQuantityStockUnit',
        label: this.$t('amount') as string,
        formatter: (row: IManufacturingPlan) => formatQuantityWithUnit(row.plannedQuantityStockUnit, row.stockUnit),
      },
      {
        prop: 'manufactureCompletionDate',
        label: this.$t('barcode.lot') as string,
        formatter: (row: IManufacturingPlan) => {
          if (!row.manufactureCompletionDate) return ''
          return parseDateToYYMMDD(row.manufactureCompletionDate)
        },
      },
      { prop: 'companyCode', label: this.$t('company_code') as string, width: 150 },
    ]
  }

  getNestedValue(obj: Record<string, unknown>, path: string): unknown {
    return getNestedValue(obj, path)
  }
}
